import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MotionMedia from "./MotionMedia";
import { track } from "../lib/analytics";
import "./HomeHero.css";

export default function HomeHero() {
 return (
<section data-testid="home-story-hero" aria-labelledby="home-story-title" className="home-story-hero relative h-screen min-h-[720px] -mt-20 flex items-center justify-center overflow-hidden">
<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({"@context": "https://schema.org", "@type": "VideoObject", "name": "Full turnkey villa renovation in Dubai \u2014 from design to handover", "description": "TIME Furniture brand film illustrating in-house demolition, civil rebuilding, MEP installation, bathroom renovation, joinery, furnishing and handover.", "thumbnailUrl": "https://timefurniture.ae/media/turnkey-revision-oct5/time-furniture-dubai-full-turnkey-renovation-20261005.webp", "contentUrl": "https://timefurniture.ae/media/turnkey-revision-oct5/time-furniture-dubai-full-turnkey-renovation-20261005.mp4", "uploadDate": "2026-10-05T15:00:00+04:00", "duration": "PT30S", "publisher": {"@type": "Organization", "name": "TIME Furniture", "url": "https://timefurniture.ae/"}}) }} />
        <div className="absolute inset-0">
          <MotionMedia
            mediaKey="home-hero"
            alt="TIME Furniture full turnkey renovation: demolition, civil rebuilding, MEP, bathroom installation, joinery, furnishing and handover in a Dubai villa"
            mode="hero"
            aspectClass="h-full w-full"
            testid="home-hero-media"
            eager
            toggleClass="top-24 right-5 md:top-28 md:right-8"
            imgClassName="animate-fade-in"
          />
          {/* Soft dark overlay for calm contrast */}
          <div className="absolute inset-0 bg-black/60 pointer-events-none" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/55 pointer-events-none" />
        </div>

        <div className="relative z-10 max-w-[1100px] mx-auto px-8 md:px-16 text-center">
          <p
            data-testid="hero-eyebrow"
            className="mb-10 md:mb-14 text-[11px] md:text-[12px] tracking-[0.44em] uppercase text-[#D4A963] hero-fade-1"
          >
            UAE · Established 1993
          </p>

          <h1
            id="home-story-title" data-testid="hero-h1"
            className="font-serif-display font-medium text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-[80px] leading-[1.06] tracking-[-0.015em] max-w-5xl mx-auto hero-fade-2"
          >
            Complete Interior <span className="whitespace-nowrap">Fit-Out</span>
            <br />
            <em className="text-[#D4A963] not-italic">&amp; Turnkey Contracting</em>
          </h1>

          <p
            data-testid="hero-subtext"
            className="mt-12 md:mt-16 max-w-2xl mx-auto text-white/85 leading-[1.7] text-base md:text-lg font-light hero-fade-3"
          >
            Villas, apartments, offices and commercial &amp; hospitality interiors — delivered by one accountable team across the UAE since 1993.
          </p>

          <div className="mt-16 md:mt-20 flex flex-col sm:flex-row gap-4 justify-center hero-fade-4">
            <Link
              to="/contact"
              data-testid="hero-cta-consultation"
              onClick={() => track.siteVisitCta("hero")}
              className="inline-flex items-center justify-center gap-3 bg-[#D4A963] text-[#1C110C] px-10 py-5 text-[11px] tracking-[0.32em] uppercase font-medium hover:bg-[#c9a166] transition-all"
            >
              Book a Site Visit <ArrowRight size={14} />
            </Link>
            <Link
              to="/portfolio"
              data-testid="hero-cta-work"
              onClick={() => track.portfolioView({ cta_location: "hero" })}
              className="inline-flex items-center justify-center gap-3 border border-white/40 text-white px-10 py-5 text-[11px] tracking-[0.32em] uppercase font-medium hover:bg-white hover:text-[#1C110C] transition-all"
            >
              View Completed Projects
            </Link>
          </div>

          <p
            data-testid="hero-trust-line"
            className="mt-10 md:mt-12 text-[10px] md:text-[11px] tracking-[0.32em] uppercase text-white/50 hero-fade-4"
          >
            In-house demolition · civil · MEP · furnishing — from start to finish
          </p>
        </div>

        {/* Discreet scroll hint */}
        <span
          data-testid="hero-scroll-hint"
          className="absolute bottom-12 left-1/2 -translate-x-1/2 text-[10px] tracking-[0.36em] uppercase text-white/50"
        >
          Scroll ↓
        </span>
      </section>
 );
}
